import React, { useEffect, useState } from 'react'
import swal from 'sweetalert';
import Breadcrumb from '../../../component/Breadcrumb';
import MappingTabing from '../../../component/MappingTabing';
import { Link } from 'react-router-dom';
import { Box, Button, Grid, Typography } from '@mui/material';
import Loader from '../../../component/Loader/Loader';
import MappingConnectionTable from './MappingConnectionTable';
import AddressModal from '../../Can/AddressModal';
import { optionsRight } from '../../../constants';
import { fetchAutoCompleteSheetData, getAddressDataType } from '../../../api/mappingApi';
import { checklocalStorageItems, saveContentFile } from '../../../utlis';

const MappingConnections = () => {

  const [open, setOpen]                               = useState(false);
  const [showLoader, setShowLoader]                   = useState(false);
  const [connectionData,setConnectionData]            = useState([]);
  const [sheetMappingData, setSheetMappingData]       = useState([]);
  const [autoCompleteLoading, setAutoCompleteLoading] = useState(false);
  const [searchValue, setSearchValue]                 = useState('');
  const [sheetFilter, setSheetFilter]                 = useState('');
  const [updatedRParam, setUpdatedRParam]             = useState('');
  const [editableRow, setEditableRow]                 = useState('');
  const [itemForLocal, setItemForLocal]               = useState(false);

  useEffect(() => {
    const dataInLocalStorage = checklocalStorageItems();
    setItemForLocal(dataInLocalStorage);
    fetchConnectionData();
    window.addEventListener('storage',fetchConnectionData);
    return () => {
        window.removeEventListener('storage',fetchConnectionData);
    }
  },[])

  const fetchConnectionData = () => {
    setShowLoader(true);
    let connections = JSON.parse(localStorage.getItem('Connections'));
    if(connections != null && connections.length > 0){
      setConnectionData(connections);
    }
    setShowLoader(false);
  }

  const handleAddButton = () => {
    window.open('/connections','_blank','noopener,noreferrer,width=auto,height=auto')
  }  


  const handleClickOpen = (row) => {
    setEditableRow(row)
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
    setSearchValue('');
    setSheetFilter('');
    setEditableRow('');
  };

  const handleSheetFilter = (e) => {
    setSheetFilter(e.target.value)
  }

  const handleSearchValueAutoComplete = (value) => {
    setSearchValue(value)
  }

  useEffect(() => {
    if(searchValue === ''){
        setSheetMappingData([]);
        return;
    }
    let active;
    if(sheetFilter){
        active = true;
        ( async () => {
                setAutoCompleteLoading(true);
                const data = await fetchAutoCompleteSheetData('',sheetFilter,searchValue);
                if(active){
                    setSheetMappingData(data);
                    setAutoCompleteLoading(false);
                }
            }
        )();
    }
    return () => {
        active = false;
    }
  },[sheetFilter,searchValue])

  const handleChangeAutoComplete = async (value) => {
    const address = value?.Address ? value?.Address : '';
    let result = await getAddressDataType(editableRow.LParam);
    if(value?.DataType !== result?.datatype){
      swal({
        title: "Oops",
        text: 'DataType of Addresses does not match. Connection can not be created.',
        icon: "error",
      })
      return;
    }
    setUpdatedRParam(address);
  }

  const handleModalSubmit = () => {
    setOpen(false);
    setSearchValue('');
    setSheetFilter('');
    let existingConnections = JSON.parse(localStorage.getItem('Connections'));
    if(existingConnections != null && existingConnections.length > 0){
      existingConnections =  existingConnections.map((conn) =>  {
        if(conn.LParam === editableRow.LParam){
          return {...conn, 'RParam' : updatedRParam}
        } else {
          return conn;
        }
      });
    } 
    localStorage.setItem('Connections',JSON.stringify(existingConnections));
    fetchConnectionData();
    setEditableRow('');
  } 

  const handleRowDelete = (rowIndex) => {
    const newArray = [...connectionData];
    newArray.splice(rowIndex, 1);
    setConnectionData(newArray);
    if(newArray.length === 0){
        localStorage.removeItem("Connections");
    } else {
        localStorage.setItem('Connections',JSON.stringify(newArray));
    }
  }

  const handleConfigFileContent = async() => {
    setShowLoader(true);
    const result = await saveContentFile();
    setShowLoader(false);
    if(result){
        swal({
          title: "Success",
          text: result.message,
          icon: "success",
        })
    }
  }

  return (
    <>
      {showLoader && 
        <Loader />
      }
      <Breadcrumb  title="Configuration Connections">
          <Typography component={Link} to="/" variant="subtitle2" color="primary" className="link-breadcrumb">
          Dashboard
          </Typography>
          <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
          Connections
          </Typography>
      </Breadcrumb>
      <MappingTabing 
        value="connection" 
        handleConfigFileContent={handleConfigFileContent}
      />
      <Box  component="section">
        <Grid className="contentBox">
          {itemForLocal &&
            <Grid className="modbusButtons" container direction="row" display={'flex'} justifyContent={{ xs: 'flex-end',sm:'flex-end' }}>
              <Grid item>
                  <Button
                      onClick={handleAddButton}
                      variant="contained"
                      size="small"
                      color="primary"
                      sx={{mr:3}}
                  >Add 
                  </Button>
              </Grid>
            </Grid>
          }
          {connectionData.length === 0  &&
              <p>No Data Available.</p>
          }
          <MappingConnectionTable 
            data={connectionData}
            handleClickOpen={handleClickOpen}
            handleRowDelete={handleRowDelete}
          />
          <AddressModal 
            open={open}
            options={optionsRight}
            autoCompleteName={"RParam"}
            onClose={handleClose}
            sheetFilter={sheetFilter}
            handleSheetFilter={handleSheetFilter} 
            handleModalSubmit={handleModalSubmit}
            autoCompleteOptions={sheetMappingData}
            autoCompleteLoading={autoCompleteLoading}
            handleChangeAutoComplete={handleChangeAutoComplete}
            handleSearchValueAutoComplete={handleSearchValueAutoComplete}
          />
        </Grid>
      </Box>
    </>    
  )
}

export default MappingConnections